import { render, staticRenderFns } from "./MsFooter.vue?vue&type=template&id=472bfe0e&scoped=true"
import script from "./MsFooter.vue?vue&type=script&lang=js"
export * from "./MsFooter.vue?vue&type=script&lang=js"
import style0 from "./MsFooter.vue?vue&type=style&index=0&id=472bfe0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472bfe0e",
  null
  
)

export default component.exports